import { useMemo } from 'react';
import useMediaQuery from '@mui/material/useMediaQuery';
import { CellCreatedOn, CellProjectName, CellProjectTags, CellOwner } from '../Cells';

export default function useProjectsTableColumns() {
  const isDesktop = useMediaQuery('(min-width:900px)');
  const hasTagging = true; // useHasGroupFeature('userTagging');
  // const isInternalUser = useIsInternalUser();

  return useMemo(() => [
    {
      accessor: 'name',
      id: 'name',
      Header: 'Name',
      Cell: CellProjectName,
      minWidth: 305,
    },
    isDesktop && hasTagging ? {
      accessor: 'tags',
      id: 'tags',
      Header: 'Tags',
      Cell: CellProjectTags,
      minWidth: 175,
      maxWidth: 0,
    } : null,
    isDesktop ? {
      accessor: 'owner',
      id: 'owner',
      Header: 'Owner',
      Cell: CellOwner,
      width: 80,
    } : undefined,
    isDesktop ? {
      accessor: 'createdOn',
      id: 'createdOn',
      Header: 'Created On',
      Cell: CellCreatedOn,
      minWidth: 80,
      width: 80,
    } : undefined,
  ].filter(Boolean), [isDesktop, hasTagging]);
}

export { useProjectsTableColumns };